/* eslint-disable custom/no-unsafe-stitches-tokens */
import { withOnClickTracking } from 'auto-tracking';
import { Icon, styled, theme } from 'design-system';
import { useTranslation } from 'next-i18next';

type PeerPilotHeaderProps = {
  onClick?: () => void;
};

export const PeerPilotHeader = ({ onClick }: PeerPilotHeaderProps) => {
  const { t } = useTranslation('homepage');

  return (
    <TrackedContainer
      onClick={onClick}
      trackingName="peerpilot-header-click"
      trackingProperties={{
        sectionName: 'PeerPilot Header',
        elementName: t('peerpilot.header.scrollPrompt'),
      }}
    >
      <ContentWrapper>
        <GlitterIcon>✨</GlitterIcon>

        <TextContainer>
          <NewText>{t('peerpilot.header.new')}</NewText>
          <MainText>{t('peerpilot.header.mainText')}</MainText>
          <Icon
            name="ArrowDown"
            size="1x"
            variant={'regular'}
            color={theme.colors.white.value}
          />
        </TextContainer>
      </ContentWrapper>

      <ArrowIcon>↓</ArrowIcon>
    </TrackedContainer>
  );
};

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-1px)',
    opacity: 0.9,
  },
});

const TrackedContainer = withOnClickTracking(Container);

const ContentWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const GlitterIcon = styled('span', {
  fontSize: '16px',
});

const TextContainer = styled('div', {});

const NewText = styled('span', {
  fontFamily: '$inter',
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0px',
  textTransform: 'uppercase',
  color: theme.colors.white,
});

const MainText = styled('span', {
  fontFamily: '$inter',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.colors.white,
  marginLeft: '4px',
  marginRight: '8px',
});

const ArrowIcon = styled('span', {
  fontSize: '16px',
  color: theme.colors.white,
});
